module.exports = __webpack_public_path__ + "media/images/business/bg-symbol-04c3862849bd24bc57ac0bba2bcd79df.svg";